import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lessonStructure", "thirdFourthStudentStructure"]

  connect() {
    this.updateThirdFourthStudentStructureVisibility()
  }

  updateThirdFourthStudentStructureVisibility() {
    if (!this.hasLessonStructureTarget || !this.hasThirdFourthStudentStructureTarget) return

    const shouldShow = this.lessonStructureTarget.value === "turns"

    this.thirdFourthStudentStructureTarget.classList.toggle("u-hidden", !shouldShow)
    this.thirdFourthStudentStructureTarget
      .querySelectorAll("select")
      .forEach((field) => {
        if (!shouldShow) field.value = "observe_only"
      })
  }
}
